import { IAction } from 'helpers/interfaces';
import { ChecksumReportTypes } from '../../actions/backoffice/checksum-report-actions';

interface IState {
    data?: [] | null;
    totalNumberOfElements: number | null;
    hashAlgorithms: string[] | null;
    loading: boolean;
}

export const initialState: IState = {
    data: null,
    totalNumberOfElements: null,
    hashAlgorithms: null,
    loading: false,
};

const checksumReducer = (state: IState = initialState, actions: IAction) => {
    switch (actions.type) {
        case ChecksumReportTypes.CHECKSUM_REPORT_REQUEST: {
            return {
                ...state,
                loading: true,
            };
        }

        case ChecksumReportTypes.CHECKSUM_REPORT_SUCCESS: {
            return {
                ...state,
                data: actions.payload.content,
                totalNumberOfElements: actions.payload._metadata.totalNumberOfElements,
                hashAlgorithms: actions.payload.hashAlgorithms,
                loading: false,
            };
        }

        case ChecksumReportTypes.CHECKSUM_REPORT_CLEAR: {
            return {
                ...state,
                data: null,
                totalNumberOfElements: 0,
                loading: false,
            };
        }

        default:
            return state;
    }
};

export default checksumReducer;
